import { css } from 'styled-components'

export const transition = `all 0.2s ease-in-out`

// TODO Preferably we be using keyframes from styled-components here

export const appear = css`
  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const slideIn = css`
  @keyframes slideIn {
    0% {
      transform: translateX(-2%);
    }
    100% {
      transform: translateX(0);
    }
  }
`

export const shrink = css`
  @keyframes shrink {
    0% {
      width: 95%;
    }
    100% {
      width: 90%;
    }
  }
`
